module.exports = __webpack_public_path__ + "images/assets/8d01ad396cb79fb80ffb75bff0a4efbc.svg";